/* ⚠️ GENERATED from app/services/vouchedAccounts.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/vouchedAccounts.ts — the three accounts Allo itself vouches for, and
// the one place that decides which they are.
//
// 🟥 THE SAME TICK WAS WRITTEN OUT TWENTY TIMES, IN TWO DIFFERENT BLUES. Every
//    surface that shows a name inlined its own `<Ionicons name="checkmark-circle"
//    size={14} color="#4285F4" />`, and MessageBubble's copy is #1D9BF0 — so the
//    official account already wears two different marks in one product depending
//    on where you look at it.
//
// 🟥 AND THE CHAT LIST'S OWN ROW SAID IT THREE TIMES IN A ROW. Three adjacent
//    blocks, one per account, each rendering an identical icon — which is how the
//    card that opens UNDER that row came to have none at all: there was no rule
//    to forget, only three copies to not write a fourth time.
//
// 🟢 SO: ONE QUESTION, ASKED OF A UID. Not "is this the official account" three
//    times over — "does Allo vouch for this account", which has one answer and
//    one mark.

import { isOfficialUid } from './support';

/** The assistant. Its uid is a constant on both clients and on the server. */
export const AI_UID = 'allo-ai-bot';
/**
 * Which of the three this is, or null for an ordinary account.
 *
 * 🟢 NOTE TO SELF COUNTS, and it is not a stretch. The row already ticked it:
 *    the mark answers "is this really who it says it is", and the chat with
 *    yourself is the one account in the list you can be completely certain of.
 *
 * 🟥 `myUid` IS REQUIRED FOR THAT, AND MUST NOT DEFAULT. A missing viewer used to
 *    make `uid === undefined` an accidental match for any account with no uid —
 *    so a half-loaded row would wear a tick it had not earned.
 */
export function vouchedKind(uid, myUid) {
  const id = String(uid || '').trim();
  if (!id) return null;
  if (isOfficialUid(id)) return 'official';
  if (id === AI_UID) return 'ai';
  const me = String(myUid || '').trim();
  if (me && id === me) return 'self';
  return null;
}

/** Does this account wear the tick? */
export function isVouched(uid, myUid) {
  return vouchedKind(uid, myUid) !== null;
}

/**
 * The same question asked of a CHAT rather than of a uid — the chat list and the
 * chat header hold one of these, not the other person's account.
 *
 * 🟥 A GROUP IS NEVER VOUCHED. It has no single identity to vouch for, and an
 *    earlier version of this test read `chat.participants.includes(...)` — which
 *    is true of any group the official account has ever been added to.
 */
export function vouchedChat(chat, myUid) {
  if (!chat || chat.isGroup) return null;
  if (chat.isOfficial === true) return 'official';
  const other = chat.otherUser?.uid || chat.uid || null;
  return vouchedKind(other, myUid);
}

/**
 * 🟢 ONE BLUE. The two in the tree are Google's #4285F4 (the chat list, the
 *    profile screens, the forward sheet) and Twitter's #1D9BF0 (message
 *    bubbles). The first is what almost every surface already draws, so it is
 *    the one that changes nothing where anybody is looking.
 */
export const VOUCHED_BLUE = '#4285F4';
